(function () {
  function init() {
    document.querySelectorAll('[data-wcy-live-search]').forEach(initLiveSearch);
    document.querySelectorAll('.data-thumb-slider').forEach(initGallerySize);
    var bar = document.getElementById('yvProductStickyBar');
    if (bar) {
      var queued = false;
      function update() {
        queued = false;
        var rect = bar.getBoundingClientRect(), style = getComputedStyle(bar);
        var visible = style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0;
        document.body.classList.toggle('wcy-cart-bar-visible', visible);
        document.body.style.setProperty('--wcy-cart-bar-height', Math.ceil(rect.height) + 'px');
      }
      function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
      new MutationObserver(schedule).observe(bar, { attributes: true, attributeFilter: ['style', 'class'] });
      new ResizeObserver(schedule).observe(bar);
      addEventListener('scroll', schedule, { passive: true }); addEventListener('resize', schedule); update();
    }
    document.querySelectorAll('.data-thumb-slider .yv-product-slider-item').forEach(function (item, index) {
      item.setAttribute('role', 'button'); item.tabIndex = 0;
      item.setAttribute('aria-label', 'Vis produktbillede ' + (index + 1));
      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        var thumb = window.Flickity && window.Flickity.data(item.closest('.data-thumb-slider'));
        var mainId = thumb && thumb.options.asNavFor;
        var main = mainId && window.Flickity.data(document.querySelector(mainId));
        if (main) main.select(index); else item.click();
      });
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { document.querySelectorAll('[data-wcy-live-search]').forEach(initLiveSearch); document.querySelectorAll('.data-thumb-slider').forEach(initGallerySize); });
  function initGallerySize(element) {
    if (element.dataset.wcySizeReady) return;
    element.dataset.wcySizeReady = 'true';
    var queued = false;
    function schedule() {
      if (queued) return; queued = true;
      requestAnimationFrame(function () {
        queued = false;
        var slider = window.Flickity && window.Flickity.data(element);
        if (slider && element.clientWidth > 0) slider.resize();
      });
    }
    new ResizeObserver(schedule).observe(element);
    // Variant media updates can replace the native slider without replacing its element.
    new MutationObserver(schedule).observe(element, { childList: true, attributes: true, attributeFilter: ['class'] });
    schedule();
  }
  function initLiveSearch(form) {
    if (form.dataset.liveSearchReady) return;
    form.dataset.liveSearchReady = 'true';
    var input = form.querySelector('input[name="q"]'), results = form.querySelector('.wcy-search-results');
    var status = form.querySelector('[data-wcy-search-status]');
    var timer, controller, revision = 0, composing = false, cache = new Map();
    function close() { results.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function cancel() { clearTimeout(timer); revision++; if (controller) controller.abort(); }
    function open() { results.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function allLink(term) {
      var url = new URL(form.action, location.href); url.searchParams.set('q', term); url.searchParams.set('options[prefix]', 'last');
      var link = document.createElement('a'); link.href = url.href; link.className = 'all_results_link'; link.textContent = 'Se alle resultater'; return link;
    }
    function render(html, term) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var section = parsed.querySelector('#shopify-section-predictive-search-lite');
      if (!section) throw new Error('Missing search results');
      results.innerHTML = section.innerHTML;
      results.querySelectorAll('script').forEach(function (node) { node.remove(); });
      results.querySelectorAll('img').forEach(function (image) {
        if (image.dataset.src) { image.src = image.dataset.src.replace(/\{width\}/g, '128'); image.classList.remove('lazyload'); image.classList.add('lazyloaded'); }
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        image.loading = 'eager';
      });
      // One keyboard stop per product; both original image/title links still work.
      results.querySelectorAll('.searchbar-product-img').forEach(function (link) { link.tabIndex = -1; });
      if (!results.querySelector('.all_results_link')) results.appendChild(allLink(term));
      results.setAttribute('aria-busy', 'false');
      status.textContent = results.querySelector('.search-bar-no-results') ? 'Ingen forslag. Du kan se alle resultater.' : 'Søgeforslag er klar. Brug pil ned for at vælge.';
      open();
    }
    async function search(term, version) {
      if (cache.has(term)) { render(cache.get(term), term); return; }
      controller = new AbortController();
      results.replaceChildren(); var loading = document.createElement('p'); loading.className = 'wcy-search-message'; loading.textContent = 'Søger…'; results.appendChild(loading);
      results.setAttribute('aria-busy', 'true'); status.textContent = 'Søger…'; open();
      var url = new URL(form.action.replace(/\/$/, '') + '/suggest', location.href);
      url.searchParams.set('section_id', 'predictive-search-lite'); url.searchParams.set('q', term);
      url.searchParams.set('resources[type]', form.dataset.searchTypes || 'product,query');
      url.searchParams.set('resources[options][fields]', 'author,tag,title,product_type,variants.title,vendor,variants.sku');
      try {
        var response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        var html = await response.text();
        if (version !== revision || !form.isConnected || input.value.trim() !== term) return;
        render(html, term); cache.set(term, html); if (cache.size > 20) cache.delete(cache.keys().next().value);
      } catch (error) {
        if (error.name === 'AbortError' || version !== revision || !form.isConnected) return;
        results.replaceChildren(); var message = document.createElement('p'); message.className = 'wcy-search-message'; message.textContent = 'Forslag kunne ikke hentes. Se alle resultater for din søgning.';
        results.appendChild(message); results.appendChild(allLink(term)); results.setAttribute('aria-busy', 'false'); status.textContent = message.textContent; open();
      }
    }
    function update() {
      cancel(); close(); status.textContent = ''; var term = input.value.trim();
      if (!term || composing) { results.replaceChildren(); return; }
      var version = revision; timer = setTimeout(function () { search(term, version); }, 180);
    }
    input.addEventListener('input', update);
    input.addEventListener('compositionstart', function () { composing = true; cancel(); });
    input.addEventListener('compositionend', function () { composing = false; update(); });
    input.addEventListener('focus', function () { if (results.hidden && input.value.trim()) update(); });
    form.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { input.focus(); cancel(); close(); event.preventDefault(); return; }
      if (results.hidden || ['ArrowDown', 'ArrowUp'].indexOf(event.key) < 0) return;
      var links = Array.from(results.querySelectorAll('a[href]')).filter(function (link) { return link.tabIndex >= 0; });
      if (!links.length) return;
      var index = links.indexOf(document.activeElement);
      var next = event.key === 'ArrowDown' ? index + 1 : index < 0 ? links.length - 1 : index - 1;
      event.preventDefault(); if (next < 0) input.focus(); else links[next % links.length].focus();
    });
    form.addEventListener('focusout', function () { setTimeout(function () { if (!form.contains(document.activeElement)) { cancel(); close(); } }, 0); });
    document.addEventListener('pointerdown', function (event) { if (!form.contains(event.target)) { cancel(); close(); } });
    form.addEventListener('submit', function () { cancel(); close(); });
  }
})();

